export default function PlayButton() {
  return (
    <svg
      width="25"
      height="26"
      viewBox="0 0 25 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Play Button</title>
      <rect
        x="0.40918"
        y="0.837891"
        width="24.4063"
        height="24.4063"
        rx="12.2032"
        fill="#131313"
        fill-opacity="0.4"
      />
      <rect
        x="0.738995"
        y="1.16771"
        width="23.7467"
        height="23.7467"
        rx="11.8733"
        stroke="#FBFBFB"
        stroke-opacity="0.4"
        stroke-width="0.65963"
      />
      <path
        d="M12.6116 19.7271C13.9341 19.7271 15.2269 19.3349 16.3266 18.6002C17.4262 17.8654 18.2833 16.8211 18.7894 15.5992C19.2955 14.3774 19.4279 13.0329 19.1699 11.7358C18.9119 10.4387 18.275 9.2472 17.3399 8.31204C16.4047 7.37687 15.2132 6.74002 13.9161 6.482C12.619 6.22399 11.2745 6.35641 10.0527 6.86252C8.83082 7.36863 7.78649 8.22569 7.05173 9.32533C6.31698 10.425 5.9248 11.7178 5.9248 13.0403C5.9248 14.8138 6.6293 16.5146 7.88332 17.7686C9.13734 19.0226 10.8382 19.7271 12.6116 19.7271ZM12.6116 8.02522C13.6035 8.02522 14.5731 8.31935 15.3978 8.87041C16.2226 9.42148 16.8654 10.2047 17.2449 11.1211C17.6245 12.0375 17.7238 13.0459 17.5303 14.0187C17.3368 14.9915 16.8592 15.8852 16.1578 16.5865C15.4564 17.2879 14.5628 17.7655 13.59 17.959C12.6172 18.1526 11.6088 18.0532 10.6924 17.6737C9.77602 17.2941 8.99277 16.6513 8.4417 15.8266C7.89063 15.0018 7.5965 14.0322 7.5965 13.0403C7.5965 11.7102 8.12488 10.4346 9.06539 9.49411C10.0059 8.55359 11.2815 8.02522 12.6116 8.02522Z"
        fill="#FBFBFB"
      />
      <path
        d="M11.3813 15.4497C11.5149 15.5211 11.6653 15.555 11.8165 15.5477C11.9678 15.5403 12.1142 15.492 12.2402 15.4079L14.7477 13.7362C14.8624 13.6599 14.9564 13.5564 15.0214 13.435C15.0865 13.3136 15.1205 13.178 15.1205 13.0403C15.1205 12.9026 15.0865 12.767 15.0214 12.6456C14.9564 12.5242 14.8624 12.4208 14.7477 12.3445L12.2402 10.6728C12.1143 10.5888 11.9679 10.5405 11.8167 10.5332C11.6655 10.5259 11.5152 10.5597 11.3818 10.6312C11.2483 10.7026 11.1368 10.809 11.0591 10.9388C10.9813 11.0687 10.9403 11.2173 10.9404 11.3686V14.712C10.9403 14.8634 10.9812 15.0119 11.0588 15.1418C11.1365 15.2718 11.248 15.3781 11.3813 15.4497Z"
        fill="#FBFBFB"
      />
    </svg>
  );
}
